import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import httpInterceptor from "../common/APIConfig";

// Async thunk for deleting cron schedule
export const deleteCron = createAsyncThunk(
  "cron/deleteCron",
  async (payload, { rejectWithValue }) => {
    try {
        const response = await httpInterceptor.delete(
            "/resources/aws/cron",
            { data: payload })
            if (response.status === 200) {
                return response.data
            }
        } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const deleteCronSlice = createSlice({
  name: "deleteCron",
  initialState: {
    loading: false,
    success: false,
    error: null,
  },
  reducers: {
    resetDeleteCronState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteCron.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(deleteCron.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(deleteCron.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { resetDeleteCronState } = deleteCronSlice.actions;
export default deleteCronSlice.reducer;
